import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'
import EditPictureButton from './EditPictureButton'
import UploadPicture from '../UploadPicture'
import { Colors } from '../../Themes'
import placeholder from '../../../public/img/Defaults/default_user.png'

const AvatarContainer = styled.div`
  position: relative;
  height: ${props => parseInt(props.size, 10) || 38}px;
  width: ${props => parseInt(props.size, 10) || 38}px;
`

const Picture = styled.div`
  position: absolute;
  height: ${props => parseInt(props.size, 10) || 38}px;
  width: ${props => parseInt(props.size, 10) || 38}px;
  border: ${props => (props.withBorder ? 'solid 1px ' + Colors.black : 'none')};
  border-radius: 50%;
  background: url('${props => props.imageSrc}') no-repeat center;
  background-size: cover;
`

class Avatar extends Component {
  shouldComponentUpdate (nextProps) {
    const { imageSrc } = this.props
    if (nextProps.error || nextProps.imageSrc !== imageSrc) {
      return true
    }
    return false
  }

  render () {
    const {
      onEdit,
      size,
      handleError,
      error,
      imageSrc,
      withBorder,
      buttonClass
    } = this.props
    return onEdit ? (
      <UploadPicture
        uploadButton={
          <EditPictureButton className={buttonClass} pictureSize={size} />
        }
        handleUploaded={onEdit}
        handleError={handleError}
        error={error}>
        <AvatarContainer {...this.props}>
          <Picture
            size={size}
            imageSrc={imageSrc || placeholder}
            widthBorder={withBorder}
            className='picture'
          />
        </AvatarContainer>
      </UploadPicture>
    ) : (
      <AvatarContainer {...this.props}>
        <Picture
          size={size}
          imageSrc={imageSrc || placeholder}
          widthBorder={withBorder}
          className='picture'
        />
      </AvatarContainer>
    )
  }
}

Avatar.propTypes = {
  imageSrc: PropTypes.string,
  size: PropTypes.number,
  withBorder: PropTypes.bool,
  onEdit: PropTypes.func,
  handleError: PropTypes.func,
  error: PropTypes.string,
  buttonClass: PropTypes.string
}

export default Avatar



// WEBPACK FOOTER //
// ./src/components/Avatar/index.js